import React from 'react';
import { Minus, Plus, Trash, X as CloseIcon } from 'phosphor-react';
import { translate } from '../Services/translation';
import QuantityInput from './QuantityInput';
import StockStatusTag from './StockStatusTag';
import OptionData from './OptionData';

export default (props) => {
  const { product, onQuantityChange, deleteRow } = props;
  const {
    image,
    name,
    campaignPercentage,
    campaignPrice,
    price,
    articleNumber,
    totalPrice,
    totalCampaignPrice,
    baseProductName,
    quantity,
    category,
    size,
    isInStock,
    stockStatusDescription,
    isConfigurator,
    optionData,
    stockStatusType,
    discountPercentage,
  } = product;

  return (
    <div className="cart-container__item-wrapper">
      <div className="cart-container__item">
        <div
          style={{ position: 'relative' }}
          className="cart-container__image-wrapper"
        >
          <img alt="" src={image} />
          {discountPercentage > 0 && (
            <span className="[ sales-tag ] [ lh-1 ]">
              {discountPercentage}%
            </span>
          )}
        </div>
        <div className="cart-container__item-details">
          <Trash
            size="16"
            className="cart-container__item-delete"
            onClick={deleteRow}
            color="#B91C1C"
          />
          <div className="[ cart-container__item-articlenumber ] [ text-small lh-2 color-grey-500 ]">
            {translate('cart.art-nr')} {articleNumber}
          </div>
          <div className="[ cart-container__item-name ] ">
            <a
              className="[ text-medium lh-2 color-grey-900 ]"
              href={product.url}
            >
              {baseProductName}
            </a>
          </div>
          {category && (
            <div className="[ cart-container__item-category ] [ text-small lh-1 color-grey-500 ]">
              {category}
            </div>
          )}
          {size && (
            <div className="[ cart-container__item-size ] [ text-small lh-1 color-grey-500 ]">
              {translate('cart.item.size')} {size}
            </div>
          )}
          {optionData && <OptionData optionData={optionData} />}
          {campaignPrice && (
            <div className="cart-container__campaign-price lh-1">
              <span className="cart-container__item-price lh-1">
                {totalCampaignPrice}
              </span>
              <span className="cart-container__item-price-old lh-1">
                {totalPrice}
              </span>
              <span className="cart-container__item-campaign-percentage lh-1">
                {campaignPercentage}
              </span>
            </div>
          )}
          {!campaignPrice && (
            <div className="cart-container__item-price lh-1">{price}</div>
          )}
          {discountPercentage > 0 && (
            <span className="[ cart-container__discount-saving ] [ text-small lh-1 ]">
              {translate('cart.you-save')} {discountPercentage}%
            </span>
          )}
          {
            <StockStatusTag
              isInStock={isInStock}
              description={stockStatusDescription}
              stockStatusType={stockStatusType}
            />
          }
        </div>
      </div>
      <div className="cart-container__item-footer">
        {!isConfigurator ? (
          <QuantityInput
            onQuantityChange={onQuantityChange}
            quantity={quantity}
          />
        ) : (
          <div></div>
        )}
        {totalPrice && (
          <div className="cart-container__total-price">
            <span className="text-small color-grey-500 lh-1">
              {translate('cart.total')}
            </span>
            <span className="text-medium color-grey-900 lh-1 bold">
              {totalCampaignPrice ? totalCampaignPrice : totalPrice}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
